export default "__VITE_ASSET__51e36039__"